document.addEventListener('DOMContentLoaded', () => {
  const fixedEl = document.querySelector('.o-collection__fixed');
  const contentEl = document.querySelector('.o-collection__content');
  const sliderEl = document.querySelector('.o-collection__slider');

  if (!fixedEl || !contentEl || !sliderEl) return;

  const breakpoint = 780;

  const resetFixed = () => {
    fixedEl.classList.remove('js-collec-fixed');
    fixedEl.style.width = '';
    fixedEl.style.left = '';
  };

  const syncFixedPosition = () => {
    const sliderRect = sliderEl.getBoundingClientRect();
    fixedEl.style.width = `${sliderRect.width}px`;
    fixedEl.style.left = `${sliderRect.left}px`;
  };

  const handleScroll = () => {
    if (window.innerWidth < breakpoint) {
      resetFixed();
      return;
    }

    const contentTop = contentEl.getBoundingClientRect().top;

    if (contentTop <= 0) {
      fixedEl.classList.add('js-collec-fixed');
      syncFixedPosition();
    } else {
      resetFixed();
    }
  };

  window.addEventListener('scroll', handleScroll);

  window.addEventListener('resize', () => {
    if (window.innerWidth < breakpoint) {
      resetFixed();
    } else if (fixedEl.classList.contains('js-collec-fixed')) {
      syncFixedPosition();
    }
  });
});
